<template>
  <collapsed-card collapse-key="mss-soc-overview">
    <div class="d-flex flex-row justify-content-between w-100" slot="title">
      <h2 class="phairify-cc-box-title mb-0">Overview</h2>
      <b-button v-if="!isGmAdminType" variant="primary" @click="toManageSociety">Edit</b-button>
    </div>
    <b-card
      no-body
      class="rounded-0 shadow-none phairify-card__group-box h-100 mss-society-overview__card"
    >
      <b-row v-if="society">
        <b-col md="6" xl="3" class="phairify-card__deck mt-sm-3 mt-md-0">
          <b-card class="phairify-card__group-box h-100 h-100">
            <template v-slot:header>
              <div class="header group-box__header">
                <h3>Specialties</h3>
              </div>
            </template>
            <div
              class="phairify-lime-box h-100 mb-2 mb-lg-0 phairify-body-copy"
            >
              <div><b>Specialties:</b></div>
              <div
                v-for="({ title = '' }, index) in specialties"
                :key="index"
                class="text-center"
              >
                {{ title }}
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md="6" xl="3" class="phairify-card__deck mt-sm-3 mt-md-0">
          <b-card class="phairify-card__group-box h-100">
            <template v-slot:header>
              <div class="header group-box__header">
                <h3>Membership</h3>
              </div>
            </template>
            <div
              class="phairify-lime-box h-100 mb-2 mb-lg-0 phairify-body-copy"
            >
              <div class="text-center">
                <b>Total Members:</b>{{ ' ' }}
                {{ society.memberEmailsCount }}
              </div>
              <div class="text-center"><b>Registrations:</b> {{ ' ' }}{{ society.usersCount }}</div>
              <div class="text-center" v-if="!isGmAdminType">
                <b-button
                  variant="primary"
                  class="my-3"
                  size="sm"
                  to="/mss-admin/manage/members"
                >
                  View Members
                </b-button>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md="12" xl="6" class="phairify-card__deck mt-sm-3 mt-xl-0">
          <b-card class="phairify-card__group-box h-100">
            <template v-slot:header>
              <div class="header group-box__header">
                <h3>Contacts</h3>
              </div>
            </template>
            <b-row class="h-100">
              <b-col sm="12" md="6" class="mb-2 mb-lg-0">
                <div
                  class="phairify-lime-box h-100 phairify-body-copy text-center"
                >
                  <b class="mb-2">Phairify Representative</b>
                  <div>{{ internalPersonName }}</div>
                  <div>{{ internalPersonPhone }}</div>
                  <div>{{ internalPersonEmail }}</div>
                </div>
              </b-col>
              <b-col sm="12" md="6" class="mb-2 mb-lg-0">
                <div
                  class="phairify-lime-box h-100 phairify-body-copy text-center"
                >
                  <b class="mb-2">Society</b>
                  <div v-if="society.contact1_email || society.contact1_name">
                    <b>Primary:</b> {{ society.contact1_name }},
                    {{ society.contact1_email }}
                  </div>
                  <div v-if="society.contact2_email || society.contact2_name">
                    <b>Secondary:</b> {{ society.contact2_name }},
                    {{ society.contact2_email }}
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <div v-else>
        <HalfCircleSpinner />
        <div class="spinner-message my-3 text-center">
          Loading the data...
        </div>
      </div>
    </b-card>
  </collapsed-card>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners';
import SocietyDataProvider from '@/mixins/SocietyDataProvider';
import CollapsedCard from '@/components/ui-elements/CollapsedCard';

export default {
  name: 'SocietyOverview',
  mixins: [SocietyDataProvider],
  components: {
    HalfCircleSpinner,
    CollapsedCard,
  },
  props: {
    society: {
      required: true,
      type: Object,
    },
    isGmAdminType: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    internalPersonName() {
      return this.society.internalPerson
        ? `${this.society.internalPerson.first_name} ${this.society.internalPerson.last_name}`
        : '';
    },
    internalPersonPhone() {
      return this.society.internalPerson
        ? `${this.society.internalPerson.phone_num}`
        : '';
    },
    internalPersonEmail() {
      return this.society.internalPerson
        ? `${this.society.internalPerson.email}`
        : '';
    },
    specialties: function () {
      return (this.society || {}).specialties || [];
    },
  },
  methods: {
    toManageSociety() {
      this.$router.push('/mss-admin/manage/society');
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/variables_mixins.scss';

.mss-society-overview__card {
  padding: 20px 15px;
  margin-bottom: 5px;
  .phairify-card__deck .phairify-card__group-box {
    margin: 0;
  }
  .phairify-lime-box {
    padding: 10px 15px;
  }
}
</style>
